import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
export function useScrollspy(ids, options) {
  const $ = _c(4);
  const [activeId, setActiveId] = useState();
  const observerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== ids || $[1] !== options) {
    t0 = () => {
      const elements = ids.map(_temp);
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
      observerRef.current = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        }
      }, options);
      for (const el of elements) {
        if (el) {
          observerRef.current.observe(el);
        }
      }
      return () => observerRef.current?.disconnect();
    };
    t1 = [ids, options];
    $[0] = ids;
    $[1] = options;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return activeId;
}
function _temp(id) {
  return document.querySelector(`#${id}`);
}